function capitalizeFirstLettervariant(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function getColorFromUrlvariant(){
    const url = window.location.href;
    const pathPartsvariant = url.split('/');
    let color = null;

    for (let i = 0; i < pathPartsvariant.length; i++) {
        const part = pathPartsvariant[i];
             const validPattern = /^(women-|men-)[a-zA-Z]+$/;

        if (validPattern.test(part) && !part.includes('?')) {
            color = part.replace(/women-|men-/i, '');
            color = color.split('?')[0];
            color = capitalizeFirstLettervariant(color);
            break;
        }
    }
  
    return color;
}

let chosenColor = getColorFromUrlvariant();


   

if (chosenColor){
   
 const filterWidget = document.querySelector('.m-filter--widget[data-index="6"]');


if (filterWidget) {
    filterWidget.remove();
    console.log('Removed the filter widget element with data-index="6"');
}
const mainProductCards = document.querySelectorAll('.m-product-item');
    
    mainProductCards.forEach(card => {
        const colorSwatchElement = card.querySelector(`.m-product-option--content [data-value="${chosenColor}"]`);
        if (!colorSwatchElement) {
            card.remove();
            console.log(`Removed product card without color: ${chosenColor}`);
        }
    });}

